<label for="{{id}}">{{t label}}</label>

<input type="date" id="{{id}}" name="{{../name}}" {{#if attributes}}data-attributable{{/if}}>
{{#if (equal helptext.position 'bottom')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}